import React from 'react';
import { Link } from 'react-router-dom';

const Cookies = () => {
  return (
    <div className="mx-auto max-w-4xl px-6 py-12 md:px-12">
      <h1 className="animate-fade-in mb-8 text-4xl font-bold md:text-5xl">Cookie Policy</h1>

      <div className="animate-fade-in space-y-8" style={{ animationDelay: '200ms' }}>
        <section>
          <h2 className="mb-4 text-2xl font-bold">What Are Cookies?</h2>
          <p className="mb-4 text-lg text-gray-400">
            Cookies are small text files that are placed on your device when you visit our website.
            They help us provide you with a better experience by remembering your preferences and
            understanding how you use our site.
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-bold">How We Use Cookies</h2>
          <p className="mb-4 text-lg text-gray-400">We use cookies for the following purposes:</p>
          <ul className="list-inside list-disc space-y-2 text-lg text-gray-400">
            <li>Essential cookies for site functionality</li>
            <li>Performance cookies to improve our service</li>
            <li>Authentication cookies to remember your login status</li>
            <li>Preference cookies to remember your settings</li>
          </ul>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-bold">Types of Cookies We Use</h2>
          <div className="space-y-4">
            <div>
              <h3 className="mb-2 text-xl font-semibold">Essential Cookies</h3>
              <p className="text-lg text-gray-400">
                Required for basic site functionality. These cannot be disabled.
              </p>
            </div>
            <div>
              <h3 className="mb-2 text-xl font-semibold">Performance Cookies</h3>
              <p className="text-lg text-gray-400">
                Help us understand how visitors interact with our website.
              </p>
            </div>
            <div>
              <h3 className="mb-2 text-xl font-semibold">Functionality Cookies</h3>
              <p className="text-lg text-gray-400">Remember your preferences and settings.</p>
            </div>
          </div>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-bold">Managing Cookies</h2>
          <p className="mb-4 text-lg text-gray-400">
            Most web browsers allow you to control cookies through their settings preferences.
            However, limiting cookies may affect your experience of our website.
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-bold">Updates to This Policy</h2>
          <p className="mb-4 text-lg text-gray-400">
            We may update this Cookie Policy from time to time. Any changes will be posted on this
            page with an updated revision date.
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-bold">More Information</h2>
          <p className="mb-4 text-lg text-gray-400">
            For more information about how we protect your privacy, please see our{' '}
            <Link to="/privacy" className="text-accent hover:opacity-80">
              Privacy Policy
            </Link>{' '}
            and{' '}
            <Link to="/trust" className="text-accent hover:opacity-80">
              Trust Center
            </Link>
            .
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-bold">Contact Us</h2>
          <p className="mb-4 text-lg text-gray-400">
            If you have any questions about our Cookie Policy, please contact us at{' '}
            <a href="mailto:privacy@ohhebe.us" className="text-accent hover:opacity-80">
              privacy@ohhebe.us
            </a>
          </p>
        </section>
      </div>
    </div>
  );
};

export default Cookies;
